'use client'

import classNames from 'classnames'
import {
  CartItemFragment,
  ProductType,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { useSearchParams, usePathname, ReadonlyURLSearchParams } from 'next/navigation'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'

export type FakePart =
  | 'fake_req_info'
  | 'fake_non_returnable'
  | 'fake_only_config'
  | 'fake_max_quantity_reached'
  | 'fake_general_info'
  | 'fake_reverse_vat_info'

const containsFake = (name: FakePart, searchParams: ReadonlyURLSearchParams) => {
  const params = searchParams.get(name)

  return params != null
}

export const useSpoofedUi = () => {
  const searchParams = useSearchParams()
  const { serverEnv } = useSiteContext()

  if (serverEnv === 'production') return null

  return {
    alterCartItems: (cartItems: CartItemFragment[]) => {
      if (containsFake('fake_req_info', searchParams)) {
        cartItems.map(
          p =>
            (p.product!.requiredEndUserInformation = [
              { lineNumber: 0, label: 'Some mandatory info', isMandatory: true },
              { lineNumber: 1, label: 'Some non-mandatory info', isMandatory: false },
            ])
        )
      }

      if (containsFake('fake_non_returnable', searchParams)) {
        cartItems.map(p => (p.product!.nonReturnable = true))
      }

      if (containsFake('fake_only_config', searchParams)) {
        cartItems.map(p => {
          p.product!.productType = ProductType.Config
          p.product!.availability!.isIncludedInKit = false
        })
      }

      if (containsFake('fake_max_quantity_reached', searchParams)) {
        cartItems.map(p => (p.product!.availability!.maxAvailableQuantity = 0))
      }
    },
    cartGeneralInfo: containsFake('fake_general_info', searchParams)
      ? 'Some general info for cart goes here (Cart_GeneralInformation resource)'
      : null,
    reverseVatInfo: containsFake('fake_reverse_vat_info', searchParams)
      ? "Reverse VAT info goes here, but this site doesn't support it (Reverse_Vat_info resource)"
      : null,
  }
}

export const CartsiteDevAdmin = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const searchPrams = new URLSearchParams(location.search)

  const onClick = (name: FakePart) => () => {
    if (searchPrams.has(name)) searchPrams.delete(name)
    else searchPrams.append(name, 'true')

    if (searchPrams.toString().length > 0) location.href = `${pathname}?${searchPrams.toString()}`
    else location.href = pathname
  }

  return (
    <>
      <button
        className={classNames({ 'u-bg-red': containsFake('fake_req_info', searchParams) })}
        onClick={onClick('fake_req_info')}>
        Required end-user info
      </button>
      <button
        className={classNames({ 'u-bg-red': containsFake('fake_non_returnable', searchParams) })}
        onClick={onClick('fake_non_returnable')}>
        Non-returnable product
      </button>
      <button
        className={classNames({ 'u-bg-red': containsFake('fake_only_config', searchParams) })}
        onClick={onClick('fake_only_config')}>
        Only config products
      </button>
      <button
        className={classNames({
          'u-bg-red': containsFake('fake_max_quantity_reached', searchParams),
        })}
        onClick={onClick('fake_max_quantity_reached')}>
        Max quantity reached
      </button>
      <button
        className={classNames({ 'u-bg-red': containsFake('fake_general_info', searchParams) })}
        onClick={onClick('fake_general_info')}>
        Cart general info
      </button>
      <button
        className={classNames({ 'u-bg-red': containsFake('fake_reverse_vat_info', searchParams) })}
        onClick={onClick('fake_reverse_vat_info')}>
        Reverse VAT info
      </button>
    </>
  )
}
